import React, { useState, useEffect } from "react";
import styles from "./galeria_estudio_amsterdam_ink.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes, FaArrowUp } from "react-icons/fa";

// Import das imagens
import PretoEBranco1 from './src/galeria/pretoebranco1.jpeg';
import PretoEBranco2 from './src/galeria/pretoebranco2.jpeg';
import PretoEBranco3 from './src/galeria/pretoebranco3.jpeg';
import PretoEBranco4 from './src/galeria/pretoebranco4.jpeg';
import PretoEBranco5 from './src/galeria/pretoebranco5.jpeg';
import PretoEBranco6 from './src/galeria/pretoebranco6.jpeg';
import PretoEBranco7 from './src/galeria/pretoebranco7.jpeg';
import PretoEBranco8 from './src/galeria/pretoebranco8.jpeg';
import PretoEBranco9 from './src/galeria/pretoebranco9.jpeg';
import PretoEBranco10 from './src/galeria/pretoebranco10.jpeg';
import PretoEBranco11 from './src/galeria/pretoebranco11.jpeg';
import PretoEBranco12 from './src/galeria/pretoebranco12.jpeg';
import PretoEBranco13 from './src/galeria/pretoebranco13.jpeg';
import PretoEBranco14 from './src/galeria/pretoebranco14.jpeg';
import PretoEBranco15 from './src/galeria/pretoebranco15.jpeg';
import PretoEBranco16 from './src/galeria/pretoebranco16.jpeg';
import Colorida1 from './src/galeria/colorida1.jpeg';
import Colorida2 from './src/galeria/colorida2.jpeg';
import Colorida3 from './src/galeria/colorida3.jpeg';
import Colorida4 from './src/galeria/colorida4.jpeg';
import Colorida5 from './src/galeria/colorida5.jpeg';
import Colorida6 from './src/galeria/colorida6.jpeg';
import Colorida7 from './src/galeria/colorida7.jpeg';
import Colorida8 from './src/galeria/colorida8.jpeg';
import Colorida9 from './src/galeria/colorida9.jpeg';

const Galeria_estudio_amsterdam_ink: React.FC = () => {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [categoria, setCategoria] = useState<"pretoebranco" | "colorida">("pretoebranco");
    const [showScrollTop, setShowScrollTop] = useState(false);

    // Listas de imagens separadas por categoria
    const imagensPretoEBranco = [PretoEBranco1, PretoEBranco2, PretoEBranco3, PretoEBranco4, PretoEBranco5, PretoEBranco6, PretoEBranco7, PretoEBranco8, PretoEBranco9, PretoEBranco10, PretoEBranco11, PretoEBranco12, PretoEBranco13, PretoEBranco14, PretoEBranco15, PretoEBranco16];
    const imagensColoridas = [Colorida1, Colorida2, Colorida3, Colorida4, Colorida5, Colorida6, Colorida7, Colorida8, Colorida9];

    // Seleciona a lista atual com base na categoria
    const imagensAtuais = categoria === "pretoebranco" ? imagensPretoEBranco : imagensColoridas;

    const openLightbox = (index: number) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);
    const prevImage = () =>
        setCurrentIndex((prev) => (prev === 0 ? imagensAtuais.length - 1 : prev - 1));
    const nextImage = () =>
        setCurrentIndex((prev) => (prev === imagensAtuais.length - 1 ? 0 : prev + 1));

    // --- Mostrar botão "voltar ao topo" após rolar ---
    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className={styles.galeria_estudio_amsterdam_ink}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/estudio_amsterdam_ink" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">Galeria</h1>
            </div>

            {/* FILTRO - Preto e Branco / Coloridas */}
            <div className={styles.filterBar}>
                <button
                    className={`${styles.filterButton} ${categoria === "pretoebranco" ? styles.active : ""
                        }`}
                    onClick={() => setCategoria("pretoebranco")}
                >
                    Preto e Branco
                </button>
                <button
                    className={`${styles.filterButton} ${categoria === "colorida" ? styles.active : ""
                        }`}
                    onClick={() => setCategoria("colorida")}
                >
                    Coloridas
                </button>
            </div>

            {/* CONTEÚDO - Galeria */}
            <div className={styles.content}>
                <div className={styles.galleryGrid}>
                    {imagensAtuais.map((img, index) => (
                        <div
                            key={index}
                            className={styles.imageContainer}
                            onClick={() => openLightbox(index)}
                        >
                            <img src={img} alt={`${categoria} ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <div className={styles.lightbox}>
                    <button className={styles.closeBtn} onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button className={styles.prevBtn} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img
                        src={imagensAtuais[currentIndex]}
                        alt={`${categoria} ${currentIndex + 1}`}
                        className={styles.lightboxImage}
                    />
                    <button className={styles.nextBtn} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}

            {/* BOTÃO FLUTUANTE */}
            {showScrollTop && (
                <button className={styles.scrollTopButton} onClick={scrollToTop}>
                    <FaArrowUp />
                </button>
            )}

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a
                        href="https://wa.me/5519997384163?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <WhatsappIcon height="30" color="#ffffff" />
                            </div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/fatyLvdgWNE2uE3z8" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <MapsIcon height="30" color="#ffffff" />
                            </div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a
                        href="https://www.instagram.com/estudio_amsterdam_ink?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Galeria_estudio_amsterdam_ink;
